import React from 'react';
import { Button } from './ui/button';
import { useNavigate } from 'react-router-dom';
import haircut from "../assets/images/haircut.jpg";

const Haircut = () => {
  const navigate = useNavigate();

  const handleBookAppointment = () => {
    navigate('/');
    setTimeout(() => {
      document.getElementById('book-appointment')?.scrollIntoView({ behavior: 'smooth' });
    }, 500);
  };

  return (
    <div className="pt-20">
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">Haircut Services</h1>
              <p className="text-gray-700 leading-relaxed mb-4">
                A JOKER & QUINN cut is always special. Our highly trained staff will design a custom appearance using characteristic cutting techniques to complement your uniqueness, lifestyle, and hair structure.
              </p>
              <p className="text-gray-700 leading-relaxed mb-6">
                We offer precision cuts for all hair types and styles, from classic to contemporary looks.
              </p>
              <Button
                className="bg-black hover:bg-gray-800 text-white px-8 py-4 rounded-full"
                onClick={handleBookAppointment}
              >
                Book Appointment
en              </Button>
            </div>
            <div>
              <img src={haircut} alt="Haircut" className="rounded-lg shadow-xl w-full h-[500px] object-cover" />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Haircut;
